var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup5209(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.777,
    height: 36.952,
    viewBox: "0 0 26.777 36.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.198,
    y1: -0.243,
    x2: 0.762,
    y2: 0.739,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#82ff92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56b956"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.198,
    y1: -0.243,
    x2: 0.762,
    y2: 0.739,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9af6a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bad47"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5209",
    "data-name": "Group 5209",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M4646.285-1494.027c0,1.462-1.186.539-2.587.89-.755.108-.732-.059-1.24.046-.686.141-.814.039-.817-.661,0-.77.013-1.541,0-2.31a.6.6,0,0,1,.531-.7c1.024-.228,2.042-.483,3.063-.73.685-.166.994.064,1,.756C4646.226-1494.972,4646.281-1495.787,4646.285-1494.027Z",
    transform: "translate(-4619.508 1514.552)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M4537.933-1661.695c0-1.444-.113-2.9.021-4.329a12.691,12.691,0,0,1,4.4-8.484,13.108,13.108,0,0,1,8.154-3.348,13.422,13.422,0,0,1,13.878,10.881,1.244,1.244,0,0,1-.981,1.607c-.375.11-.754.213-1.136.3-.562.125-.87-.107-.937-.683a10.288,10.288,0,0,0-8.7-8.839,10.2,10.2,0,0,0-11.371,7.936,16.6,16.6,0,0,0-.243,2.755c-.041,1.052,0,2.106-.017,3.159,0,.344.1.539.461.564.139.009.274.063.414.085a.565.565,0,0,1,.54.64c-.014.833,0,1.666-.007,2.5,0,.516-.184.667-.672.549l-.882-.213c-.016,0,.233,15.712.146,15.691-.665-.163-1.395-.346-2.122-.537-.524-.137-.667-.23-.707-.685,0-.027-.006-.139-.006-.272C4538.175-1643.6,4537.9-1661.695,4537.933-1661.695Z",
    transform: "translate(-4537.888 1677.879)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M4604.773-1605.355c.006-1.776.025-3.9.117-5.668a4.182,4.182,0,0,1,3.673-3.564,4.209,4.209,0,0,1,4.587,3.33,7.134,7.134,0,0,1,.084,1.217c.033.725.292,1.028,1.005,1.111a10.606,10.606,0,0,0,1.443.1c.445-.01.651-.33.695-.752a7.416,7.416,0,0,0-5.735-8.02,7.355,7.355,0,0,0-8.852,5.967,8.388,8.388,0,0,0-.093,1.217c-.009,2.326-.012,3.582-.039,5.908,0,.361-.034,1.443-.034,1.443,0,2.326,0,4.652,0,6.978a8.129,8.129,0,0,0,.093,1.217,7.353,7.353,0,0,0,8.851,5.967,7.415,7.415,0,0,0,5.735-8.02c-.042-.422-.249-.742-.7-.752a10.541,10.541,0,0,0-1.442.1c-.714.083-.974.386-1.005,1.111a7.036,7.036,0,0,1-.084,1.217,4.211,4.211,0,0,1-4.586,3.33,4.184,4.184,0,0,1-3.674-3.564c-.092-1.771-.035-3.55-.043-5.326,0-.278.1-.376.41-.342.653.072,1.314.116,1.971.135a48.385,48.385,0,0,0,8.592-.459c.42-.063.577-.238.574-.676-.012-2.013-.012-.819-.01-2.833a57.248,57.248,0,0,1-5.882.307c-3.546.024-3.927-.119-5.2-.16-.351-.011-.464-.162-.461-.493Z",
    transform: "translate(-4595.636 1623.457)",
    fill: "#343548"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5209);
export default __webpack_public_path__ + "static/media/Group 5209.93346874861291a0dfca590a71cf953e.svg";
export { ForwardRef as ReactComponent };